import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { useModalStore } from '@features/modal'

import { URL_CUSTOMER_ORDERS, URL_CUSTOMER_PROFILE } from '@shared/contants'
import { Slot } from '@shared/generated'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

export default function SuccessModal ({
  id,
  selectSlot,
}: {
  id: string;
  selectSlot: Slot | null;
}) {
  const { t: tc } = useTranslation('common')
  const { t: to } = useTranslation('order')
  const navigate = useNavigate()
  const { closeModal } = useModalStore()
  const handleClick = () => {
    navigate(`${URL_CUSTOMER_PROFILE}/${URL_CUSTOMER_ORDERS}`)
    closeModal('successPaymentOrder')
  }
  return (
    <div className={styles.successModal}>
      <h3 className={styles.successModal__title}>
        <Trans
          ns="order"
          i18nKey="order.success"
          values={{ id }}
          components={[ <span className={styles.highlight} /> ]}
        />
      </h3>
      <p className={styles.successModal__time}>
        {tc('delivery')} {selectSlot?.slotDate}, {tc('from')}{' '}
        {selectSlot?.slotTime?.split(' - ').join(to('up_to'))}
      </p>
      <Button className={styles.successModal__button} onClick={handleClick}>
        {to('watch_order')}
      </Button>
    </div>
  )
}
